$(document).on('input', function (e) {
    if (window.showLoading) {
        window.activeElement = document.activeElement;
        document.activeElement.blur();
    }
});
